import { useAnalytics } from '@sketch/modules-common'
import { useEffect, useRef } from 'react'
import { PrototypeFileFragment } from '@sketch/gql-types'
import { useDidBrowserTabChange } from '@sketch/utils'

type UsePrototypeViewLoadDurationProps = {
  loaded: boolean
  prototypeFile?: PrototypeFileFragment['prototypeFile']
}

export function usePrototypeLoadDurationMetric(
  props: UsePrototypeViewLoadDurationProps
) {
  const { loaded, prototypeFile } = props
  const startTime = useRef(Date.now())
  const generatedOnDemand = useRef(false)
  const didBrowserTabChangeRef = useDidBrowserTabChange()
  const { trackMetric } = useAnalytics()
  useEffect(() => {
    if (prototypeFile?.status === 'PENDING') {
      generatedOnDemand.current = true
    }
  }, [prototypeFile?.status])

  useEffect(() => {
    if (!loaded) return
    if (didBrowserTabChangeRef.current) return

    trackMetric({
      id: 'webapp_prototype_view_load_duration_milliseconds',
      value: Date.now() - startTime.current,
      labels: {
        generatedOnDemand: generatedOnDemand.current ? 'true' : 'false',
      },
    })
  }, [loaded, didBrowserTabChangeRef, trackMetric])
}
